import { AccountApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const userApi = {
  show: wrap(AccountApi, AccountApi.prototype.showUser),
  update: wrap(AccountApi, AccountApi.prototype.updateUser),
  updateEmail: wrap(AccountApi, AccountApi.prototype.updateUserEmail),
  updatePassword: wrap(AccountApi, AccountApi.prototype.updateUserPassword),
  revokeToken: wrap(AccountApi, AccountApi.prototype.revokeToken),
  customerList: wrap(AccountApi, AccountApi.prototype.customerList),
  salesmanList: wrap(AccountApi, AccountApi.prototype.salesmanList),
  administratorList: wrap(AccountApi, AccountApi.prototype.administratorList),
  deleteCustomer: wrap(AccountApi, AccountApi.prototype.deleteCustomer),
  deleteSalesman: wrap(AccountApi, AccountApi.prototype.deleteSalesman),
  downloadCustomerList: wrap(AccountApi, AccountApi.prototype.downloadCustomerList),
};
